export const SPECIFICITY_OF_PRODUCT_API_END_POINT = process.env.RAZZLE_SPECIFICITY_OF_PRODUCT_API_END_POINT || 'specificity-of-products'
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
